import { render } from "./MemberPortalMain.vue?vue&type=template&id=d085c4a6&ts=true"
import script from "./MemberPortalMain.vue?vue&type=script&lang=ts"
export * from "./MemberPortalMain.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__